import { FunctionalModal } from 'component/modal/functional-modal';
import { t } from 'util/stdtypes';

export const ConfirmLeaveModal = ({ onClose, onConfirm }: { onClose: () => void; onConfirm: () => void }) => (
    <FunctionalModal
        headingLabel={t('comment.confirm_leave_heading', 'Are you sure you want to leave?')}
        onClose={onClose}
        primaryButton={{ label: t('modal.confirm_leave_button', 'Leave'), type: 'delete', onPress: onConfirm }}
        secondaryButton={{ label: t('modal.cancel_button', 'Cancel'), type: 'secondary', onPress: onClose }}
        subheadingLabel={t('comment.confirm_leave_description', "The changes you made won't be saved.")}
    />
);
